import { L10n } from "@syncfusion/ej2-base";
import {
  Agenda,
  Day,
  Inject,
  Month,
  ScheduleComponent,
  Week,
  WorkWeek,
} from "@syncfusion/ej2-react-schedule";
import React, { use, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Header } from "../components";
import Modal from "../components/Modal";
import { useLazyGetFormQuery } from "../redux/formService";
import { useGetRedevablesQuery } from "../redux/redevableService";
import { usePostRedevanceMutation } from "../redux/redevanceService";
import {
  useAddEventMutation,
  useGetEventsQuery,
  useLazyGetEventsQuery,
} from "../redux/services/eventService";

const Calendar = () => {
  const [addEvent] = useAddEventMutation();
  const [eventData, setEventData] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [fields, setFields] = useState([]);
  const [filteredEvents, setFilteredEvents] = useState([]);
  const [addDisabled, setAddDisabled] = useState(true);

  const { data: redevablesData } = useGetRedevablesQuery(
    { page: 1, size: 1000 },
    { refetchOnMountOrArgChange: true }
  );
  const[getEvents, { data: eventsData }] = useLazyGetEventsQuery();
  const [getForm] = useLazyGetFormQuery();
  const [postRedevance] = usePostRedevanceMutation();

  // Configuration de la localisation française
  L10n.load({
    fr: {
      schedule: {
        day: "Jour",
        week: "Semaine",
        workWeek: "Semaine de travail",
        month: "Mois",
        agenda: "Agenda",
        today: "Aujourd'hui",
        noEvents: "Aucun événement",
        allDay: "Toute la journée",
        start: "Début",
        end: "Fin",
      },
    },
  });

  const handleAddEvent = async (data) => {
    try {
      await addEvent({ data }).unwrap();
      toast.success("Événement ajouté avec succès !");
      setShowForm(false);
    } catch (error) {
      console.error("Erreur lors de l'ajout de l'événement :", error);
      toast.error("Erreur lors de l'ajout de l'événement");
    }
  };

  const send = (data) => {
    const redevance = {
      typeEvent: data.typeOeuvre,
      type: 11,
      redevable: +data.redevable,
      montant: +data.montant,
      date: new Date(data.date_debut),
      status: false,
    };

    postRedevance({ data: redevance })
      .unwrap()
      .then(() => {
        toast.success("Redevance ajoutée avec succès !");
        setEventData(data);
        handleAddEvent(data);
      })
      .catch((error) => {
        console.error("Erreur lors de l'ajout de la redevance :", error);
        toast.error("Erreur lors de l'ajout de la redevance");
      });
  };

  useEffect(() => {
    if (eventsData?.data) {
      const formattedEvents = eventsData.data.map((event) => ({
        Id: event.id,
        Subject: event.attributes.name,
        Location: event.attributes.lieu,
        StartTime: event.attributes.date_debut,
        EndTime: event.attributes.date_fin,
        CategoryColor: "#1aaa55",
      }));
      setFilteredEvents(formattedEvents);
    }
  }, [eventsData]);

  useEffect(() => {
    const fetchFormFields = async () => {
      const response = await getForm(17);
      const formFields = response?.data?.data.attributes.fields.data || [];
      if (redevablesData?.data) {
        const redevableField = {
          id: "redevable",
          attributes: {
            field_id: "redevable",
            name: "redevable",
            type: "select",
            placeholder: "Sélectionner un redevable",
            options: redevablesData.data.map((item) => ({
              label: item.attributes.name,
              value: item.id,
            })),
            required: true,
          },
        };
        setFields([...formFields, redevableField]);
      } else {
        setFields(formFields);
      }
    };
    fetchFormFields();
  }, [getForm, redevablesData]);

  useEffect(() => {
    setAddDisabled(
      !fields.some((field) => field.attributes?.field_id === "redevable")
    );
  }, [fields]);

  useEffect(() => {
    getEvents() .unwrap()
    .then((response) => {
      const events = response.data.map((event) => ({
        Id: event.id,
        Subject: event.attributes.name,
        Location: event.attributes.lieu,
        StartTime: event.attributes.date_debut,
        EndTime: event.attributes.date_fin,
        CategoryColor: "#1aaa55",
      }));
      setFilteredEvents(events);
    })
    .catch((error) => {
      console.error("Erreur lors de la récupération des événements :", error);
      toast.error("Erreur lors de la récupération des événements");
    }); 
  }, []);

 

  return (
    <div className="m-2 md:m-20 mt-24 p-2 md:p-10 bg-white rounded-3xl">
      <Header category="App" title="Calendar" />
      <button
        disabled={addDisabled}
        type="button"
        onClick={() => {
          setShowForm(true);
          setEventData(null);
        }}
        className="mb-4 p-2 bg-primary text-white rounded-2xl px-4 py-2 text-base font-semibold hover:bg-primary/70 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
        Ajouter un événement
      </button>
      <Modal
        toSelect={null}
        toSelect2={null}
        showForm={showForm}
        send={send}
        setShowForm={setShowForm}
        fields={fields || []} // Assurez-vous que fields est un tableau
        selectedData={eventData || null} // Assurez-vous que selectedData est un objet
      />
      {filteredEvents?.length === 0 ? ( // Vérification ajoutée
        <div className="flex justify-center items-center h-full">
          <p className="text-gray-500">Chargement des données</p>
        </div>
      ) : (
        <ScheduleComponent
          height="650px"
          // locale="fr"
          eventSettings={{ dataSource: filteredEvents || [] }} // Vérification ajoutée
          dateFormat="yyyy/MM/dd"
          selectedDate={new Date()}>
          <Inject services={[Day, Week, WorkWeek, Month, Agenda]} />
        </ScheduleComponent>
      )}
    </div>
  );
};

export default Calendar;
